import React from 'react';
import ContactInfo, { ContactInfoProps } from './contact-info';
import { createRoot } from 'react-dom/client';

export default function initializeContactInfo(elementOrId: HTMLElement | string, props: ContactInfoProps): void {
  let element;
  if (typeof elementOrId === 'string') {
    element = window.document.getElementById(elementOrId);
  } else {
    element = elementOrId;
  }
  const root = createRoot(element);
  root.render(<ContactInfo {...props} />);
}
